var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"hide-header":true,"hide-footer":true,"content-class":"modal-blue","id":"pay-online-modal","size":"md"}},[_c('div',{staticClass:"row text-white content text-left"},[_c('pay-online-form',{attrs:{"pay-for-id":_vm.payForId,"type-id":_vm.typeId,"price":_vm.price,"auto-redirect":_vm.autoRedirect}})],1)])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c6c028a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pay-online-modal.vue
// module id = 752
// module chunks = 3 15 21